// extracted by mini-css-extract-plugin
module.exports = {"emailTemplateStyle":"_19HNK8TmSp5XaIxkYRcmIv"};